module.exports = __webpack_public_path__ + "img/citrixsynergy.7cda93d8.webp";